import React from 'react';
import Header from './Header';

interface RootLayoutProps {
    left: React.ReactNode;
    right: React.ReactNode;
    onAccountChange: () => void;
    onClearVideos: () => void;
}

const RootLayout: React.FC<RootLayoutProps> = ({
    left,
    right,
    onAccountChange,
    onClearVideos,
}) => {
    return (
        <div style={{ backgroundColor: '#f5f5f5' }}>
            <Header
                onAccountChange={onAccountChange}
                onClearVideos={onClearVideos}
            />
            <div
                style={{
                    display: 'flex',
                    marginTop: '16px',
                    marginLeft: '16px',
                    marginRight: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                }}
            >
                {/* Sidebar */}
                <div
                    style={{
                        width: '30%',
                        padding: '20px',
                        borderRight: '1px solid #e8e8e8',
                        backgroundColor: '#fff',
                        flexShrink: 0,
                    }}
                >
                    {left}
                </div>

                {/* Content */}
                <div
                    style={{
                        width: '70%',
                        flex: 1,
                        padding: '20px 24px',
                        backgroundColor: '#fff',
                    }}
                >
                    {right}
                </div>
            </div>
        </div>
    );
};

export default RootLayout;
